import React, { useContext } from 'react';

import ReportContext from 'contexts/ReportContext';

import QuickFilterPills from './QuickFilterPills';

const ReportQuickFiltersDisplay = () => {
  const {
    report,
    quickFilters,
    selectedQuickFilters,
    setSelectedQuickFilters,
  } = useContext(ReportContext);

  return (
    <QuickFilterPills
      quickFilters={quickFilters}
      quickFilterOrder={report?.quickFilterOrder || window.emptyArray}
      selectedQuickFilters={selectedQuickFilters}
      setSelectedQuickFilters={setSelectedQuickFilters}
    />
  );
};

export default ReportQuickFiltersDisplay;
